import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { ApiErrors, GqlRequestOptions } from '@common/api-request';

import { getUserName } from '../graphql/user-name.2';

export type AuthState = 'authenticated' | 'pending' | 'failed';

export const requestUserName = async (options: GqlRequestOptions) => {
  try {
    const { data } = await getUserName(null, { ...options, show_alert: false, ignore_error: ApiErrors.NOT_LOGGED_IN });
    return data;
  } catch (e) {
    console.error(e);
  }
};

export const useGetUserNameQuery = (enabled: boolean) => {
  return useQuery(
    ['getUserName'],
    async () => {
      const { data } = await getUserName(null, { show_alert: false, ignore_error: ApiErrors.NOT_LOGGED_IN });
      return data;
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled,
    },
  );
};

export const useIsAuthenticated = ({ enabled }: { enabled: boolean }) => {
  const [authState, setAuthState] = useState<AuthState>('pending');
  const { data, error } = useGetUserNameQuery(enabled);

  useEffect(() => {
    if (error) {
      setAuthState('failed');
      return;
    }
    if (!data) {
      return;
    }

    setAuthState(data.user_account !== null ? 'authenticated' : 'failed');
  }, [data, error]);

  return {
    isLoggedIn: authState === 'authenticated',
  };
};
